import { useCallback, useContext } from 'react';
import {
  CTA_GUARD_ACTION,
  CtaGuard,
  CtaGuardOutcome
} from '~/constants/common/ctaGuard';
import ModalContext from '~/context/vdp/ModalContext';
import { useShouldShowConfirmationModal } from '~/hooks/vdp/selectors/useConfirmModalCases';
import { logInfo } from '~/utilities/loggers';

function useConfirmBeforeLogin(): (onContinue: () => void) => () => void {
  const { setConfirmModalOpen } = useContext(ModalContext);
  const shouldShowConfirmationModal = useShouldShowConfirmationModal();

  return useCallback(
    (onContinue: () => void) => () => {
      if (shouldShowConfirmationModal) {
        logInfo(CTA_GUARD_ACTION, {
          guard: CtaGuard.ConfirmBeforeLogin,
          outcome: CtaGuardOutcome.Opened
        });

        setConfirmModalOpen(true, {
          onContinue: () => {
            logInfo(CTA_GUARD_ACTION, {
              guard: CtaGuard.ConfirmBeforeLogin,
              outcome: CtaGuardOutcome.Continued
            });

            setConfirmModalOpen(false);
            onContinue();
          },
          onlyConfirmCancellation: false
        });
      } else {
        logInfo(CTA_GUARD_ACTION, {
          guard: CtaGuard.ConfirmBeforeLogin,
          outcome: CtaGuardOutcome.Passed
        });

        onContinue();
      }
    },
    [setConfirmModalOpen, shouldShowConfirmationModal]
  );
}

export default useConfirmBeforeLogin;
